export const searchProductCardEventsConfig = {
    // Scope events specifically to the product grid on search/collection pages
    parentSelector: 'div#product-grid',
    events: {
        // Search | click on product card (CSV Line 31)
        searchProductCardClick: {
            selector: 'li.grid__item .card__heading a', // Target the heading link within a grid item
            event: {
                event: 'search', // Keep event name as 'search' per CSV
                component: 'product_card',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Exclude ATC and Quick View clicks if they bubble up to this link
                    if (element.closest('.quick-add__submit') || element.closest('.quick-view__submit')) {
                        return null; // Suppress event if click was on ATC/QuickView
                    }
                    
                    const cardWrapper = element.closest('.card-wrapper');
                    const productName = element.textContent.trim() || 'Unknown Product';
                    
                    // Get the grid item index (position)
                    const gridItem = element.closest('li.grid__item');
                    let itemIndex = -1;
                    if (gridItem && gridItem.parentElement) {
                        // Get all sibling grid items and find the index of this one
                        const allItems = Array.from(gridItem.parentElement.children);
                        itemIndex = allItems.indexOf(gridItem) + 1; // 1-based index
                    }

                    return {
                        product_name: productName,
                        link_url: element.href,
                        item_list_id: 'search_results', // Identify the list
                        item_list_name: 'Search Results', // Friendly name
                        index: itemIndex // Position in the list
                    };
                }
            }
        },
        
        // Search | click on CTA-button add to cart (CSV Line 32)
        searchProductCardATC: {
            selector: 'li.grid__item button.quick-add__submit', // Target ATC button within a grid item
            event: {
                event: 'search', // Keep event name as 'search' per CSV
                component: 'product_card',
                element: 'cta_button',
                action: 'click',
                action_value: 'add_to_cart', // Based on CSV example
                trigger: 'click',
                getDynamicData: (element) => {
                     const cardWrapper = element.closest('.card-wrapper');
                     const headingElement = cardWrapper?.querySelector('.card__heading a');
                     const productName = headingElement ? headingElement.textContent.trim() : 'Unknown Product';
                     
                      // Get the grid item index (position)
                    const gridItem = element.closest('li.grid__item');
                    let itemIndex = -1;
                    if (gridItem && gridItem.parentElement) {
                        // Get all sibling grid items and find the index of this one
                        const allItems = Array.from(gridItem.parentElement.children);
                        itemIndex = allItems.indexOf(gridItem) + 1; // 1-based index
                    }

                     return {
                         product_name: productName,
                         item_list_id: 'search_results', 
                         item_list_name: 'Search Results', 
                         index: itemIndex 
                     };
                }
            }
        }
    }
}; 